import axios from "axios";

//import { WonderPush } from 'react-wonderpush';
//window.WonderPush = window.WonderPush || [];
//WonderPush.push(['setUserId', "THIS_USER_ID"]);

import { languageService } from "../../pages/lang/Lang.js";


//const API_URL = "http://localhost:5551";
const API_URL = process.env.REACT_APP_API_URL || "https://api.pigu.chat";




export const getmessagesreal = (user) => {
  return (dispatch) => {
    axios
      .get(API_URL + "/get_messages?user=" + user)
      .then(({ data }) => {
        dispatch({ type: "MESSAGES", d: data });
      });
  };
};






export const getUser = (id) => {
  return (dispatch) => {
    axios
      .get(
        API_URL + "/getuser?id=" + id
      )
      .then(({ data }) => {
        dispatch({ type: "USER_PROFILE_DATA", d: data });
      });
  };
};






export const sendmsg = (fromu, tou, content) => {
  return (dispatch) => {

    let lang = languageService.getLanguage();
    axios
      .post(API_URL + "/send_msg", { fromu, tou, content, lang })
      .then(({ data }) => {
        //dispatch({ type: "SENT_MESSSAGE" });
        //dispatch({ type: "UPDATEPROF", d: data[0] });
        dispatch({ type: "USER_PROFILE_DATA", d: data });


      });
  };
};








export const synchProfile = (id) => {

  return (dispatch) => {
    axios
      .get(
        API_URL + "/getuser?id=" + id
      )
      .then(({ data }) => {
        //console.log(data);
        dispatch({ type: "UPDATEPROF", d: data[0] });
      });
  };
};





export const recover = (username) => {
  return (dispatch) => {

    dispatch({ type: "RESET_ERRORS" });

    axios
      .get(API_URL + "/recover?username=" + username)
      .then(({ data }) => {
        if (data.error) {
          dispatch({ type: "ERROR_RECOVERY" });
        } else {
          dispatch({ type: "RECOVERED", recovered: true });
        }
      });
  };
};

export const login = (username, pwd) => {
  return (dispatch) => {


    dispatch({ type: "RESET_ERRORS" });

    axios
      .get(API_URL + "/login?username=" + username + "&pwd=" + pwd)
      .then(({ data }) => {
        if (data.error) {
          dispatch({ type: "ERROR_LOGGING_IN" });
        } else {

          window.WonderPush = window.WonderPush || [];
          window.WonderPush.push(['setUserId', data && data.length > 0 ? data[0].id : ""]);


          dispatch({ type: "LOGGEDIN", d: data });
          window.location.href = "/chat";
        }
      });
  };
};


export const loginforced = (autologin) => {
  return (dispatch) => {

    dispatch({ type: "RESET_ERRORS" });
    //autologin


    let split = autologin.split("::");
    axios
      .get(API_URL + "/login?username=" + split[0] + "&pwd=" + split[1] + "&doi=done")
      .then(({ data }) => {
        if (data.error) {
          dispatch({ type: "ERROR_LOGGING_IN" });
        } else {

          window.WonderPush = window.WonderPush || [];
          window.WonderPush.push(['setUserId', data && data.length > 0 ? data[0].id : ""]);
          dispatch({ type: "LOGGEDIN", d: data });
          window.location.href = "/chat";
        }
      });
  };
};







export const resetErrors = () => {
  return (dispatch) => {

    dispatch({ type: "RESET_ERRORS" });

  }
};


export const checkUsername = (username, firstname, lastname, password, lang) => {
  return (dispatch) => {


    dispatch({ type: "RESET_ERRORS" });

    //utm_source:searchParams.get("utm_source"), utm_campaign:searchParams.get("utm_campaign"), utm_medium:searchParams.get("utm_medium"), utm_term:searchParams.get("utm_term"), placement:searchParams.get("placement"), s1:searchParams.get("s1"), s2:searchParams.get("s2"), s3:searchParams.get("s3")

    const searchParams = new URLSearchParams(document.location.search)

    //console.log(searchParams.get("id"));


    axios
      // .get(API_URL + "/check_username?username=" + username)
      .post(API_URL + "/check_username", { lang, email: username, firstname, lastname, password, utm_source: searchParams.get("utm_source"), utm_campaign: searchParams.get("utm_campaign"), utm_medium: searchParams.get("utm_medium"), utm_term: searchParams.get("utm_term"), placement: searchParams.get("placement"), s1: searchParams.get("s1"), s2: searchParams.get("s2"), s3: searchParams.get("s3") })

      .then(({ data }) => {
        if (data.error) {
          dispatch({ type: "ERROR_LOGGING_USERNAME" });
        } else {
          // Auto-login after registration
          window.WonderPush = window.WonderPush || [];
          window.WonderPush.push(['setUserId', data && data.length > 0 ? data[0].id : ""]);
          
          dispatch({ type: "LOGGEDIN", d: data });
          window.location.href = "/chat";
        }
      });
  };
};



export const guestLogin = (sc) => {
  return (dispatch) => {
    const guestId = localStorage.getItem("sahra_guest_id");
    axios
      .post(API_URL + "/guest_session", { sc, guest_id: guestId })
      .then(({ data }) => {
        if (data.error) return;
        if (data && data.length > 0) {
          localStorage.setItem("sahra_guest_id", data[0].id);
          dispatch({ type: "LOGGEDIN", d: data });
          dispatch({ type: "USER_PROFILE_DATA", d: data });
        }
      });
  };
};

export const phoneLogin = (phone_number) => {
  return (dispatch) => {
    dispatch({ type: "RESET_ERRORS" });

    axios
      .post(API_URL + "/phone_login", { phone_number })
      .then(({ data }) => {
        if (data.error) {
          dispatch({ type: "ERROR_PHONE_LOGIN", message: data.message || 'error' });
        } else {
          window.WonderPush = window.WonderPush || [];
          window.WonderPush.push(['setUserId', data && data.length > 0 ? data[0].id : ""]);
          dispatch({ type: "LOGGEDIN", d: data });
          window.location.href = "/chat";
        }
      });
  };
};

export const logOut = (pwd) => {
  return (dispatch) => {
    dispatch({ type: "LOGGEDOUT" });
  };
};
